export const COUNTRIES_USING_MILES = new Set(['US', 'GB', 'MM', 'LR']);

export const CONFIG = {
    geolocation: {enableHighAccuracy: false, timeout: 10000, maximumAge: 300000},
};

/** Neutral map colours match the site and keep local groups distinct. */
export const MAP_STYLES = [
    {
        elementType: 'geometry',
        stylers: [{color: '#f5f5f5'}],
    },
    {
        elementType: 'labels.icon',
        stylers: [{visibility: 'off'}],
    },
    {
        elementType: 'labels.text.fill',
        stylers: [{color: '#616161'}],
    },
    {
        elementType: 'labels.text.stroke',
        stylers: [{color: '#f5f5f5'}],
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{color: '#bdbdbd'}],
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'geometry',
        stylers: [{color: '#dddddd'}],
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{color: '#eeeeee'}],
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{color: '#ffffff'}],
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{color: '#757575'}],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{color: '#dadada'}],
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{color: '#c9c9c9'}],
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{color: '#9e9e9e'}],
    },
];
